import { Button, Dropdown, Menu, Modal, Avatar } from '@arkas/coreui';
import { InjectedIntlProps, injectIntl, FormattedMessage } from 'react-intl';
import { applicationState } from '@/states/applicationState';
import classnames from 'classnames';
import commonResources from '@/common/resources/common';
import CompanySelect from './CompanySelect';
import { connect } from 'react-redux';
import LanguageSelect from './LanguageSelect';
import { Link } from 'react-router-dom';
import { logOut } from '@/helpers/oidcHelper';
import Notifications from '@/components/Notifications/Notifications';
import React from 'react';
import store from '@/store';
import { User } from 'oidc-client';
import { UserDto } from '@emutabakat-types/anaveri';

const confirm = Modal.confirm;

interface AppHeaderButtonProps extends InjectedIntlProps {
  topMenu: boolean;
  isSmallScreen: boolean;
  darkTheme: boolean;
  user: User;
  currentUser: UserDto;
  switchMenu: (checked: boolean) => void;
  switchTheme: (checked: boolean) => void;
}

interface AppHeaderButtonStates {}

/**
 * AppHeaderButtons Component
 */
class AppHeaderButtons extends React.Component<
  AppHeaderButtonProps,
  AppHeaderButtonStates
> {
  constructor(props: AppHeaderButtonProps) {
    super(props);
    this.state = {};
    store.subscribe(() => {
      this.setState({
        seciliSirket: store.getState().kullaniciModel.seciliSirket
      });
    });
  }
  componentDidMount() {}

  showLogOutConfirm = (logOut: () => void) => () => {
    const { intl } = this.props;
    confirm({
      title: intl.formatMessage(commonResources.logoutConfirm),
      content: '',
      okText: intl.formatMessage(commonResources.ok),
      cancelText: intl.formatMessage(commonResources.iptal),
      onOk() {
        logOut();
      },
      onCancel() {}
    });
  };

  logOut = () => {
    logOut();
  };
  render() {
    const { isSmallScreen, user, currentUser } = this.props;
    const userMenu = (
      <Menu
        className="user-dropdown-menu"
        style={{ minWidth: 145 }}
        selectedKeys={[]}
      >
        <Menu.Item key="logout">
          <Link to={'#'} onClick={this.showLogOutConfirm(this.logOut)}>
            <FormattedMessage id={commonResources.cikis.id} />
          </Link>
        </Menu.Item>
      </Menu>
    );
    const avatarLetters = currentUser.isArkasUser
      ? user
        ? user.profile.given_name &&
          user.profile.family_name &&
          user.profile.given_name[0] + user.profile.family_name[0]
        : ''
      : user
        ? user.profile.given_name[0]
        : '';
    return (
      <div
        className={classnames('app-header-buttons', isSmallScreen && 'mobile')}
      >
        <div style={{ marginRight: 15 }} hidden={isSmallScreen}>
          <LanguageSelect />
        </div>
        <div style={{ marginRight: 15 }} hidden={isSmallScreen}>
          <CompanySelect />
        </div>
        <div className="header-button" style={{ marginRight: 15 }}>
          <Notifications />
        </div>
        <div className={classnames('header-button', 'user-button', 'no-badge')}>
          <Dropdown
            overlay={userMenu}
            trigger={['click']}
            placement="bottomRight"
          >
            <Button ghost={true} style={{ display: 'block' }}>
              <div style={{ display: 'flex' }}>
                <div style={{ marginRight: 8 }}>
                  <Avatar
                    style={{
                      color: '#fff',
                      backgroundColor: 'rgb(117, 160, 221)'
                    }}
                  >
                    {avatarLetters}
                  </Avatar>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 12, marginTop: 7 }}>
                    <div>
                      {currentUser.isArkasUser
                        ? user
                          ? user.profile.given_name &&
                            user.profile.family_name &&
                            `${user.profile.given_name} ${
                              user.profile.family_name
                            }`
                          : ''
                        : user
                          ? user.profile.given_name &&
                            (isSmallScreen
                              ? `${user.profile.given_name.substring(0, 10)}`
                              : `${user.profile.given_name}`)
                          : ''}
                    </div>
                  </div>
                </div>
              </div>
            </Button>
          </Dropdown>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: applicationState) => ({
  isSmallScreen: state.appModel.isSmallScreen,
  topMenu: state.appModel.topMenu,
  darkTheme: state.appModel.darkTheme,
  user: state.oidc.user,
  currentUser: state.kullaniciModel.currentUser
});

export default injectIntl(connect(mapStateToProps)(AppHeaderButtons));
